import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./mock";

const LangContext = createContext({
  lang: "en",
  setLang: () => {},
  t: translations.en,
});

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    return localStorage.getItem("lokam.lang") || "en";
  });

  useEffect(() => {
    localStorage.setItem("lokam.lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang] || translations.en;

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
